import 'css-chunk:src/components/form-fields/text-component/text-component.module.scss';export default {
  "text-component": "text-component_text-component__Lzpod",
  "disabled": "text-component_disabled__6mU0L",
  "required": "text-component_required__2oFrT",
  "input-container": "text-component_input-container__e3xsM",
  "icon": "text-component_icon__eO1Xu",
  "left": "text-component_left__J86LO",
  "right": "text-component_right__LYIDF",
  "click": "text-component_click__1JUTP",
  "second-icon": "text-component_second-icon__J1gBQ",
  "text": "text-component_text__K4ZQl",
  "ellipses": "text-component_ellipses__TEkWa",
  "white": "text-component_white__-2tW6",
  "grey": "text-component_grey__qS5rE",
  "error": "text-component_error__mwXgq",
  "text-icons-left": "text-component_text-icons-left__Dajvk",
  "text-icons-right": "text-component_text-icons-right__SwUR-",
  "error-text": "text-component_error-text__rXVKS"
};